import {Button} from "@/components/base/Buttons";
import ReviewOverlay from "@/components/base/ReviewOverlay";
import {useEffect, useState} from "react";
import styled, {css} from "styled-components";
import {breakpoints} from "@/styles/sizes";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";
import CustomDropdown from "@/components/other/CustomDropdown";
import Breadcrumbs from "@/components/other/Breadcrumbs";

const ContentWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 40px;
  transform: translate(0, -50%);

    @media only screen and (${breakpoints.mobile}) {
        top: 250px;
        left: 20px;
    }
    z-index: 9;
`;

const BreadcrumbsWrapper = styled.div`
    margin-bottom: 40px;

    @media only screen and (${breakpoints.mobile}) {
        padding: 0 20px;
    }
`;

const ImageWrapper = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 650px;
  background-image: url(${props => props.imageUrl});
  background-size: cover;
  background-position: center;

    @media only screen and (${breakpoints.mobile}) {
        height:550px;
    }
`;

const IndicatorWrapper = styled.div`
    position: absolute;
    bottom: 30px;
    left:30px;
    display: flex;
    align-items: center;
    gap:10px;
`;

const Indicator = styled.div`
    cursor: pointer!important;
    width: 10px;
    height: 10px;
    background-color: white;
    
    ${({ isActive }) => {
            if(isActive){
                return css`
                    background: transparent;
                    border: 2px solid white;
                `;
            }
        }
    }
`;


export default function StaticPageHeroSection({reviewOverlayData, heroImages,title,buttonLink,buttonText,description, dropdownData, breadcrumbs}) {


    return <div
        className={'container'}
    >
        <div style={{
            position: 'relative',
        }}>

            {dropdownData?.length > 0 && <div className={'desktop_only'}>
                <CustomDropdown items={dropdownData}/>
            </div>}

            <Carousel images={heroImages}/>

            <ContentWrapper>
                <h1 style={{
                    color: 'white',
                    fontSize:'50px',
                    fontFamily:'Playfair Display',
                    marginBottom:'30px',
                }}>{title}</h1>
                {buttonText && <Button
                    target="_blank"
                    variant={'goldLarge'}
                    href={buttonLink}
                >{buttonText}</Button>}
            </ContentWrapper>


            <div className={'desktop_only'} style={{
                position: "absolute",
                width: "100%",
                bottom: '50px',
                left: 0,
                zIndex: 999, // Ensure this is above everything else
            }}>
                <ReviewOverlay  data={reviewOverlayData} showMobile={false}/>
            </div>
            <div className={'mobile_only'} style={{zIndex: 3}}> {/* Ensure this is above everything else */}
                <ReviewOverlay data={reviewOverlayData} />
            </div>
        </div>

        <div className={'container'}  style={{marginTop:'50px'}}>
            {breadcrumbs && <BreadcrumbsWrapper>
                <Breadcrumbs items={breadcrumbs}/>
            </BreadcrumbsWrapper>}

            <DangerousDescriptionWrapper
                dangerouslySetInnerHTML={{__html: description}}
            />
        </div>

    </div>
}


const Carousel = ({images}) => {
    const [currentIndex, setCurrentIndex] = useState(0);  // Track current image index

    // Function to update image index every second
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div className={'container'} style={{position: 'relative', overflow:'hidden',}}>
            <div
                style={{
                    position:'relative',
                    width:'100%',
                    display: 'flex',
                    transition: 'transform 0.5s ease-in-out',
                    transform: `translateX(${-currentIndex * 100}%)`, // Slide effect
                }}
            >
                {images.map((item, index) => (
                    <ImageWrapper key={index} imageUrl={item?.url} />
                ))}
            </div>

            {/* Overlay */}
            <div style={{
                pointerEvents:'none',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.35)", // Black color with 50% transparency
                zIndex: 1, // Lower z-index to ensure it sits below the content
            }}/>
            <IndicatorWrapper>
                {
                    images?.map((item,index) => {
                        return <Indicator
                            key={index}
                            isActive={index === currentIndex}
                            onClick={() => setCurrentIndex(index)}
                        />;
                    })
                }
            </IndicatorWrapper>
        </div>
    );
}
